export default {
  zh_TW: {
    getRewardSucc: '領取成功~',
    noLoginGame: '您今日尚未登錄遊戲，請登錄後再來領取',
    timeEndGoStore: '活動已結束，謝謝參與。<br/>現在儲值不會獲得抽獎券獎勵，是否要繼續？',

    noLoginAccount: '請先登錄帳號',
    hasBuild: '您已領取過該禮包～不可貪心哦～',
    canNotGet: '您的簽到天數不足，無法領取當前獎勵',
    timeEnd: '活動已經結束，謝謝參與',


    allHasGet: '您已抽取所有獎勵，請等待獎池重置',
    noChance: '您的抽獎券數量不足',
    21001: '您尚未完成任意渠道儲值，無法領取抵扣券',
    21002: '抽獎券數量不足',
    '-1006': '活動已經結束，謝謝參與',
    21004: '錯誤的獎勵類型',
    21003: '獎励已抽取完畢',
    21005: '領取異常',
    21007: '領取異常',
    21006: '累計消耗抽獎券數量不足，無法領取',
    21008: '已經領取該獎勵',
    21009: '無歷史儲值記錄',
    21000: '請先登錄帳號',


    '-10002': '您已領取過該禮包～不可貪心哦～',
    '-10003': '您的建設值不足，無法解鎖當前獎勵',
    '-10005': '獲取角色出錯',
    '-19999': '非法操作',
    '-10000': '請求太頻繁',
    '-10000': '角色不存在',

    '-20001': '請先登錄帳號',
    '-20012': '活動已結束',
    '-20013': '活動還沒開始，請耐心等待',
    '-20001': '請先登錄帳號',
    '-20008': '您尚未綁定角色',
    '-20002': '您已經綁定過了',
    '-20003': '今日您已經領取過了',
    '-20004': '您今日尚未登錄遊戲，請登錄後再來領取',
    '-20005': '您今日尚未完成分享任務，請分享後再來領取',
    '-20006': '參數錯誤',
    '-20007': '您的抽獎次數不足',
    '-20009': '發獎失敗',
    '-20011': '您已經領取過該獎勵了',
    '-20010': '您尚未達到領獎條件',
    1000: '恭喜獲得禮包',
    1001: '恭喜，批量領取成功',
    1002: '您已經獲得獎勵了，請點擊【查詢獎勵序列號】查看吧',
    1003: '恭喜您獲得獎勵，請點擊【查詢獎勵序列號】查看序號吧',
    1004: '我們新手玩家也不怕落後啦，恭喜您領取成功',
    1005: '乁( ◔ ౪◔)「呵呵，成功簽到了呢',
    1006: '(๑•́ ₃ •̀๑)終於補簽成功了麼，我果然是很厲害的呀',
    1007: '恭喜獲得禮包一份喔',
    1008: '恭喜獲得禮包',
    1009: '伺服器設置成功',
    1010: '留言已提交，感謝您的參與',
    1011: '恭喜信息提交成功',
    1012: '分享成功',
    1013: '親愛的老玩家，感謝您的回歸，恭喜您領取成功',
    1014: '我們新手玩家也不怕落後啦，恭喜您領取成功',
    '-10': '活動類型不存在',
    '-11': '活動類實例化失敗',
    '-12': '活動類不是繼承活動基類',
    '-13': '調用方法不在活動類中',
    '-20': '活動id設置錯誤',
    '-21': '調用的方法不存在',
    '-22': '請先選擇遊戲',
    '-23': '抱歉！您的帳號不符合該活動對會員類型的要求',
    '-24': '您還未升級成為平臺會員，請先升級',
    '-50': '數據插入失敗',
    '-51': '數據更新失敗',
    '-100': '請設置參數：serialId',
    '-101': '請設置參數：realAccount',
    '-102': '請設置參數：gameId',
    '-103': '請設置參數：gameServerSid',
    '-104': '請設置參數：time',
    '-105': '請設置參數：ip',
    '-106': '請設置參數：activityId',
    '-110': '序號錯誤,無法通過serialId獲取序號信息',
    '-111': '序號的存儲類型錯誤',
    '-112': '無效的序號，或者已經過期',
    '-113': '該存儲類型序號的處理類未定義',
    '-114': '該存儲類型序號的處理類初始化失敗',
    '-115': '該存儲類型序號的處理類沒有實現 serialInterface 接口',
    '-116': '被導入的序號格式錯誤',
    '-117': '該序號禁止批量領取',
    '-118': '該序號的領取規則錯誤',
    '-200': '所選遊戲錯誤',
    '-201': '所選伺服器錯誤',
    '-202': '序號領取時間未開放，請稍後',
    '-203': '序號領取時間已結束，謝謝參與',
    '-204': '抱歉，序號已經被搶空了',
    '-251': '帳號已經達到活動次數限制',
    '-252': 'ip已經達到活動次數限制',
    '-253': 'fb賬戶已經達到活動次數限制',
    '-254': '電話已經達到活動次數限制',
    '-255': '郵件已經達到活動次數限制',
    '-1000': '模板不存在或者錯誤',
    '-1001':
      '( ∙̆ .̯ ∙̆ )餵餵，夠了啊，這是開加速了麼，這走馬燈是腫麼回事啊，ΣO口O~不如稍作休息吧',
    '-1002': '未知的活動時間',
    '-1003': '未知的活動',
    '-1004': '請先登入',
    '-1005': '活動還沒開始，請耐心等待',

    '-1007': '活動限制類型設置有誤',
    '-1008': '活動限制次數設置有誤',
    '-1009': '活動限制設置有誤',
    '-1010': '抱歉，您的參與次數用完了',
    '-1011': '/(ㄒoㄒ)/~~系統出錯，請稍後再試',
    '-1012': 'IP地址有誤',
    '-1013': '序號不能為空',
    '-1014': '您還沒獲得獎勵喔',
    '-1015': '系統繁忙，請稍後再試',
  },

  init: function (lang) {
    if (!!lang) {
      this.lang = lang;
    } else {
      this.lang = 'zh_TW';
    }
  },
  get: function (key) {
    var lang = this.lang;
    return this[lang][key];
  },
};
